import {
  DOCUMENT,
  EnvironmentProviders,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';

export const provideDocumentLang = (): EnvironmentProviders =>
  provideAppInitializer(() => {
    const document = inject(DOCUMENT);
    const translate = inject(TranslateService);

    const setLang = (lang: string | undefined): void => {
      if (lang) {
        document.documentElement.lang = lang;
      }
    };

    setLang(translate.currentLang || translate.defaultLang);

    translate.onLangChange
      .pipe(takeUntilDestroyed())
      .subscribe(({ lang }) => setLang(lang));
  });
